<template>
    <div class="homecontainer d-flex flex-column align-items-center h-100">

        <div class="calendario d-flex justify-content-center w-100 mt-2 flex-shrink-0">
            <div class="flechaizq">
                <DxButton
                    @click="cambiaDia(-1)"
                    width="40"
                    :element-attr="{ class: 'btn-outline'}"
                    hint="Ir al día anterior | Shift + Flecha Izquierda"
                >
                    <i class="bi bi-chevron-left"></i>
                </DxButton>
            </div>

            <div class="fecha d-flex gap-2 justify-content-center align-items-center text-black mx-4">
                <div class="dia">
                    {{ dias[hoy.getDay()] }} -
                    {{ hoy.toLocaleDateString('es-AR',{ year : 'numeric', month : '2-digit', day : '2-digit' }) }}
                </div>

            </div>

            <div class="flechader"> 
                <DxButton
                    @click="cambiaDia(1)"
                    width="40"
                    :element-attr="{ class: 'btn-outline'}"
                    hint="Ir al día siguiente | Shift + Flecha Derecha"
                >
                    <i class="bi bi-chevron-right"></i>
                </DxButton>
            </div>
        </div>

    <div class="donut-section flex-shrink-0 text-center" v-if="showPieChart">
        <div class="donut my-3" style="width: 150px; height: 150px; margin: 0 auto; position: relative;">
            <Doughnut :data="donutChartData" :options="donutOptions" :plugins="[centerTextPlugin]" />
        </div>
    </div>
    
    <div v-else class="flex-shrink-0" style="height: 20px;"></div>
<!-- GRILLA -->

    <div class="grilla flex-grow-1 w-100 d-flex flex-column" id="target">

    <!-- @selection-changed="selectionChanged" -->

    <DxDataGrid 
        id="datagrid"
        ref="myDataGrid"
        :data-source="masterDataSource"
        :show-borders="true"
        :hover-state-enabled="true"
        :selected-row-keys="selectedItemKeys"
        @row-expanding="onRowExpanding"
        :sorting="{ mode: 'none'}"
        width="95%"
        height="100%"
    >

        <DxScrolling
            show-scrollbar="true"    
        >

        </DxScrolling>
        <DxSelection 
            mode="multiple"
            show-check-boxes-mode="none"
        /> 

        <DxToolbar>

            <DxItem
                location="before"
            >
                <DxButton 
                    :element-attr="{ class: 'btn-toolbar'}"
                    @click="() => { 
                        showPieChart = !showPieChart
                    }" 
                    hint="Mostrar / Ocultar Torta">
                    <i class="bi bi-pie-chart"></i>
                </DxButton>
            </DxItem>

            <DxItem
                location="before"
                :visible="!isVisibleTarea && !isVisibleProyecto  && !isVisiblePegarCalendar"
            >
                <DxButton 
                    :element-attr="{ class: 'btn-toolbar'}"
                    @click="rows('abre')" 
                    hint="Expandir Todo | Shift + Flecha Abajo">
                    <i class="bi bi-arrows-expand"></i>
                </DxButton>
            </DxItem>

            <DxItem
                location="before"
                :visible="!isVisibleTarea && !isVisibleProyecto  && !isVisiblePegarCalendar"
            >
                <DxButton 
                    :element-attr="{ class: 'btn-toolbar'}"
                    @click="rows('cierra')" 
                    hint="Cerrar Todo | Shift + Flecha Arriba">
                    <i class="bi bi-arrows-collapse"></i>
                </DxButton>
            </DxItem>

            <DxItem
                :visible="!isVisibleTarea && !isVisibleProyecto && !isVisiblePegarCalendar"
                location="before"
                locate-in-menu="auto"
                template="separatorTemplate"
                menu-item-template="menuSeparatorTemplate"
            />

            <DxItem
                location="before"
                :visible="!isVisibleTarea && !isVisibleProyecto  && !isVisiblePegarCalendar"
            >
                <DxButton 
                    :disabled="selectedData.length == 0"
                    :element-attr="{ class: 'btn-toolbar'}"
                    @click="() => { 
                        if (authStore.confirmDelete)
                            popupVisible = true 
                        else 
                            deleteSelected()
                        }" 
                    hint="Borrar Tareas Seleccionadas">
                    <i class="bi bi-trash3"></i>
                </DxButton>
            </DxItem>

            <DxItem
                :visible="!isVisibleTarea && !isVisibleProyecto && !isVisiblePegarCalendar"
                location="before"
                locate-in-menu="auto"
                template="separatorTemplate"
                menu-item-template="menuSeparatorTemplate"
            />

            <DxItem
                location="before"
                :visible="!isVisibleTarea && !isVisibleProyecto  && !isVisiblePegarCalendar"
                template="buttonCopiar">

            </DxItem>
            <DxItem
                location="before"
                :visible="!isVisibleTarea && !isVisibleProyecto  && !isVisiblePegarCalendar"
                template="buttonPegar">
            </DxItem>
            <DxItem
                location="before"
                :visible="!isVisibleTarea && !isVisibleProyecto  && !isVisiblePegarCalendar"
                template="buttonPegarValor">
            </DxItem>
            <DxItem
                location="before"
                :visible="(!isVisibleTarea && !isVisibleProyecto) || isVisiblePegarCalendar"
                template="buttonPegarCalendar">
            </DxItem>

            <DxItem
                location="before"
                :visible="isVisiblePegarCalendar"  
            >
                <DxDateBox
                    type="date"
                    :value="pegarDesde"
                    display-format="dd/MM/yyyy" 
                    label-mode="floating"
                    label="Desde"
                    :max="pegarHasta"
                    hint="Copiar desde esta fecha inclusive"
                    @value-changed="pegarDesdeChanged"
                >
                </DxDateBox>
            </DxItem>

            <DxItem
                location="before"
                :visible="isVisiblePegarCalendar"  
            >
                <DxDateBox
                    type="date"
                    :value="pegarHasta"  
                    display-format="dd/MM/yyyy" 
                    label-mode="floating"
                    label="Hasta"
                    :min="pegarDesde"
                    hint="Copiar hasta esta fecha inclusive"
                    @value-changed="pegarHastaChanged"
                >
                </DxDateBox>
            </DxItem>

            <DxItem
                location="before"
                :visible="isVisiblePegarCalendar"
            >
                <DxCheckBox
                    :value="copiarTiempo"
                    text="Copiar Hs"
                    hint="Copiar la carga horaria"
                    @value-changed="(e) => { copiarTiempo = e.value}"
                >

                </DxCheckBox>
            </DxItem>

            <DxItem
                location="before"
                :visible="isVisiblePegarCalendar"
            >
                <DxCheckBox
                    :value="finde"
                    text="Sáb/Dom"
                    hint="Copiar incluso Sáb o Dom"
                    @value-changed="(e) => { finde = e.value}"
                >

                </DxCheckBox>
            </DxItem>

            <DxItem
                location="before"
                :visible="isVisiblePegarCalendar"
            >
                <DxButton
                    text="Pegar"
                    type="success"
                    @click="onPegarCalendar"  
                >
                </DxButton>
            </DxItem>

            <DxItem
                location="before"
                :visible="isVisiblePegarCalendar"
            >
                <DxButton
                    text="Cancelar"
                    @click="onCancelarPegarCalendar"  
                >
                </DxButton>
            </DxItem>

            <DxItem
                :visible="!isVisibleTarea && !isVisibleProyecto && !isVisiblePegarCalendar"
                location="before"
                locate-in-menu="auto"
                template="separatorTemplate"
                menu-item-template="menuSeparatorTemplate"
            />

            <DxItem
                :visible="!isVisibleTarea  && !isVisiblePegarCalendar"
                location="before"
                template="buttonProyecto">

            </DxItem>

            <DxItem
                location="center"
                :visible="isVisibleProyecto"
                >
                <DxSelectBox
                    :data-source="cbProjects"
                    :value="defaultProject"
                    display-expr="text"
                    value-expr="ProjectIndex"
                    :element-attr="selectBoxAttributes"
                    :search-enabled="true"
                    :show-clear-button="true"
                    placeholder="Seleccionar Proyecto ..."
                    no-data-text="No hay datos ..."
                    @value-changed="onNewProjectChanged"
                    width="400"
                >
                </DxSelectBox>
            </DxItem>
        
        </DxToolbar>
        <template #separatorTemplate>
            <div class="toolbar-separator"/>
        </template>

        <template #menuSeparatorTemplate>
            <div class="toolbar-menu-separator"/>
        </template>

        <template #iconProperty1>
            <i class="bi bi-coin"></i>
        </template>

        <template #iconProperty2>
            <i class="bi bi-sign-intersection-t"></i>
        </template>

        <template #buttonCopiar>
            <DxButton 
                :element-attr="{ class: 'btn-toolbar'}"
                @click="btnCopiar" 
                hint="Copiar">
                <i class="bi bi-clipboard"></i><span class="badge fondo-badge">{{ dataBadge }}</span>
            </DxButton>
        </template>

        <template #buttonPegar>
            <DxButton 
                :disabled="isPegarDisabled"
                :element-attr="{ class: 'btn-toolbar'}"
                @click="btnPegar(false)" 
                hint="Pegar">
                <i class="bi bi-clipboard-check"></i>
            </DxButton>
        </template>

        <template #buttonPegarValor>
            <DxButton 
                :disabled="isPegarDisabled"
                :element-attr="{ class: 'btn-toolbar'}"
                @click="btnPegar(true)" 
                hint="Pegar Valor">
                <i class="bi bi-clipboard2-data"></i>
            </DxButton>
        </template>

        <template #buttonPegarCalendar>
            <DxButton 
                :disabled="isPegarDisabled"
                :element-attr="{ class: 'btn-toolbar'}"
                @click="btnPegarFechas" 
                hint="Pegar en varias fechas">
                <i class="bi bi-calendar-week"></i>
            </DxButton>
        </template>

        <template #buttonProyecto>
            <DxButton 
                :element-attr="{ class: 'btn-toolbar'}"
                @click="changeisVisibleProyecto"
                :hint="hintProject">
                <i class="bi bi-folder-plus"></i>
                <span>
                    &nbsp;{{ btnProjectText }}
                </span>
            </DxButton>
        </template>

        <DxColumn 
            data-field="orden"
            caption=""
            :width=40
            cell-template="ordenTemplate"
            >
        </DxColumn>
            <template #ordenTemplate="{ data }">
                <i class="bi bi-folder-fill" :style="{ color: arrayColores[data.row.data.orden]}"></i>
            </template>

        <DxColumn 
            data-field="desc"
            caption="Proyecto"
            css-class="cell-highlighted" 
        >
        </DxColumn>

        <DxColumn 
            data-field="tiempo"
            caption="Tiempo"
            :width="80"
            header-cell-template="header-time"
        >
            <DxSorting mode="none"/>
        </DxColumn>

        <template #header-time>
          <i class="bi bi-clock"></i>
        </template>

        <DxMasterDetail
            :enabled="true"
            :auto-expand-all="true"
            template="ExtDetailTemplate"
            v-on:sumaSelected="masSelected"
            />
            <template #ExtDetailTemplate="{ data: data}">
                <ExtDetailTemplate
                    :template-data="data"
                    :gridinstance="myDataGrid"
                    :onDonutRefresh="reloadDonut"
                    :user="user"
                    :hoy="hoy"
                    v-on:sumaSelected="masSelected"

                />
            </template>

    </DxDataGrid>
    </div>  


    <DxPopup
      v-model:visible="popupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :show-title="true"
      :width="500"
      :height="200"
      title="Eliminar Tareas Seleccionadas"
    >
      <DxPosition
        at="center"
        my="center"
        of="window"
        collision="fit"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="deleteButton"
      />
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="cancelButton"
      />
      <p>
        Eliminar las Tareas Seleccionadas ??
      </p>
    </DxPopup>
</div>

</template>

<script setup>

import { DxDataGrid, 
        DxColumn,
        DxSelection,
        DxToolbar,
        DxItem,
        DxSorting,
        DxScrolling,
        DxMasterDetail} from 'devextreme-vue/data-grid'

import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'

ChartJS.register(ArcElement, Tooltip)
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxCheckBox } from 'devextreme-vue/check-box'

import CustomStore from 'devextreme/data/custom_store'
import DataSource from 'devextreme/data/data_source'

import { DxButton } from 'devextreme-vue/button'
import { DxDateBox } from 'devextreme-vue/date-box'

import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup'

import notify from 'devextreme/ui/notify'

import ExtDetailTemplate from '../components/DetailView.vue'

import { ref, computed, onMounted } from 'vue'

import {useRoute} from 'vue-router'

//---- Localization
import esMessages from '../diccionario/es.json'
import { locale, loadMessages } from "devextreme/localization";

import { useAuthStore } from '../stores/auth.js'
import { useCatalogStore } from '../stores/catalog.js'

const authStore = useAuthStore()
const catalogStore = useCatalogStore()
import tokenService from '../utils/tokenService.js'
import { useTimesStore } from '../stores/times.js'

import moment from 'moment'

const timesStore = useTimesStore()

// Debounce para cambio de día rápido
let refreshTimer = null
let loadRequestId = 0

//---- Variables

const popupVisible = ref(false)
const aceptaEliminar = ref(false)

const dataBadge = ref(null)

const isPegarDisabled = ref(true)

const showPieChart = ref(true)

const user = authStore.usuario

const myDataGrid = ref(null)
const donutItems = ref([])

const labelHoras = ref('')
const totalHorasChart = ref()

const selectedData = ref([])
const dataToCopy = ref(null)

const deleteButton = {
  text: 'Eliminar',
  stylingMode: 'outlined',
  type: 'danger',
  onClick: () => {
    popupVisible.value = false
    deleteSelected()
  },
}

const cancelButton = {
  text: 'Cancelar',
  stylingMode: 'outlined',
  type: 'normal',
  onClick: () => {
    popupVisible.value = false
    aceptaEliminar.value = false
  },
}

function toHoursAndMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    return `${padToTwoDigits(hours)}:${padToTwoDigits(minutes)} hs`;
}
  
function padToTwoDigits(num) {
    return num.toString().padStart(2, '0');
}

const isVisibleProyecto = ref(false)
const isVisibleTarea = ref(false)
const isVisiblePegarCalendar = ref(false)

const btnProjectText = ref('Proyecto')
const btnTareaText = ref('Tarea')

const hintProject = ref('Agregar Proyecto')

const btnEstiloProyecto = ref('default')
const btnEstiloTarea = ref('default')

const defaultProject = ref(null)

const selectedItemKeys = ref([])

const selectBoxAttributes = {
    style: "min-width: 300px;",
    class: 'selectbox'
}
const route = useRoute()

const routeId = route.params.fecha !== '' ? route.params.fecha + ' 00:00:00' : new Date().toISOString().split('T')[0] + ' 00:00:00'

const hoy = ref(new Date(routeId))

const pegarDesde = ref(null)
const pegarHasta = ref(null)
const copiarTiempo = ref(true)
const finde = ref(false)

let keypress = false 

const dias = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
]

const arrayColores = [
    '#AAABA8',
    '#845EC2',
    '#2C73D2',
    '#19B3EA',
    '#008E9B',
    '#00C9A7',
    '#F9F871',
    '#FFC75F',
    '#FF9671',
    '#FF6F91',
    '#BA2676',
    '#D65DB1',
    '#B39CD0'
]

function onKeyDown(e) {

    if (e.ctrlKey)
        switch (e.key) {
            case 'c' || 'C':
                btnCopiar()
                break
            case 'v' || 'V':
                btnPegar(false)
                break
            case 'd' || 'D':
                btnPegar(true)
                break
            case 'w' || 'W':
                btnPegarFechas()
                break
        }
    if (e.shiftKey)
        switch (e.key) {
            case 'ArrowRight':
                cambiaDia(1)
                break
            case 'ArrowLeft':
                cambiaDia(-1)
                break
            case 'ArrowDown':
                rows('abre')
                break
            case 'ArrowUp':
                rows('cierra')
                break
        }

}

function onRowExpanding(e) {
    e.component.collapseAll(-1)
    authStore.setIsExpanding(1)
}

function rows(accion) {
    if (accion == 'abre') {
        authStore.setIsExpanding(myDataGrid.value.instance.totalCount())
        myDataGrid.value.instance.expandAll(-1)
    }
    else {
        myDataGrid.value.instance.collapseAll(-1)
    }
}

function pegarDesdeChanged(e) {
    pegarDesde.value = e.value
}


function pegarHastaChanged(e) {
    pegarHasta.value = e.value
}

async function deleteSelected() {
    for (const key of selectedData.value) {
        await tokenService.delete('Times/' + key.ts_Id)
    }
    timesStore.invalidateDay(hoy.value.toISOString().split('T')[0])
    selectedData.value = []
    upedateamos()
}

function btnCopiar() {

    if (selectedData.value.length == 0) {
        notify("No hay elementos seleccionados", "error", 600)
        isPegarDisabled.value = true
        dataBadge.value = null
        }
    else {
        isPegarDisabled.value = false
        dataToCopy.value = selectedData.value
        dataBadge.value = dataToCopy.value.length
    }
}

async function btnPegar(valor) {
    if (dataToCopy.value.length == 0) {
        notify("P No hay elementos seleccionados para pegar ...", "error", 3000)
        }
    else {
        if (dataToCopy.value[0].ts_Fecha.split('T')[0] == hoy.value.toISOString().split('T')[0])
            notify("Estás pegando tareas de la misma fecha de la que copiaste ...", "error", 3000)
        else {
            for (const key of dataToCopy.value) {
                let newBody = {
                    usercognito: key.ts_UserCognito,
                    userId: authStore.userId,
                    fecha: hoy.value.toISOString().split('T')[0],
                    projectid: key.ts_ProjectId,
                    tipo: key.ts_Tipo,
                    tareaid: key.tareaId,
                    desc: key.tareadesc,
                    property1: key.property1,
                    property2: key.property2,
                    minutos: valor ? key.tiempo : '00:00'
                }
                await tokenService.post('Times', newBody)
            }

            timesStore.invalidateDay(hoy.value.toISOString().split('T')[0])
            upedateamos()
            dataToCopy.value = []
            dataBadge.value = null
            isPegarDisabled.value = true
            selectedData.value = []

        }
        }

}

function btnPegarFechas() {
    if (dataToCopy.value.length == 0) {
        notify("No hay elementos seleccionados para pegar ...", "error", 3000)
        }
    else {
        let pegarFecha = new Date(dataToCopy.value[0].ts_Fecha.toString().slice(0, 23))
        pegarDesde.value = moment(pegarFecha).add(1,'d').toDate()
        pegarHasta.value = moment(pegarFecha).add(2,'d').toDate()
        isVisiblePegarCalendar.value = true
    }
}


async function processDataSequential(postFecha) {
    try {
        const fechaStr = postFecha.toISOString().split('T')[0]
        for (const key of dataToCopy.value) {
            const newBody = {
                usercognito: key.ts_UserCognito,
                userId: authStore.userId,
                fecha: fechaStr,
                projectid: key.ts_ProjectId,
                tipo: key.ts_Tipo,
                tareaid: key.tareaId,
                desc: key.tareadesc,
                property1: key.property1,
                property2: key.property2,
                minutos: copiarTiempo.value ? key.tiempo : '00:00'
            };
            await tokenService.post('Times', newBody)
        }
        timesStore.invalidateDay(fechaStr)
        upedateamos();
    } catch (error) {
        console.error('Error en el proceso:', error);
        throw new Error('Problema en la Conexión de Red');
    }
}



function onPegarCalendar() {
    let postFecha = pegarDesde.value
    let diaSemana
    while (postFecha <= pegarHasta.value) {
        diaSemana = moment(postFecha).isoWeekday()
        if (!finde.value && (diaSemana == 6 || diaSemana == 7))
            postFecha = moment(postFecha).add(1,'d')
        else {
            processDataSequential(postFecha)

            postFecha = moment(postFecha).add(1,'d')
        }
    }
    isVisiblePegarCalendar.value = false
    upedateamos()
    dataToCopy.value = []
    dataBadge.value = null
    isPegarDisabled.value = true
    selectedData.value = []
}


function onCancelarPegarCalendar() {
    isVisiblePegarCalendar.value = false
}

function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText)
    }
    return response;
}

function reloadDonut() {
    const fec = hoy.value.toISOString().split('T')[0]
    donutItems.value = catalogStore.computeDonutData(timesStore, fec)
}

function upedateamos() {
    myDataGrid.value.instance.refresh()
    myDataGrid.value.instance.collapseAll()
    reloadDonut()
}


const masterDataSource = new DataSource({
    store: new CustomStore({
        key: ['ts_ProjectId','ts_Tipo', 'ts_Fecha', 'ts_UserCognito'],
        load: async () => {
            const thisRequest = ++loadRequestId
            let fec = hoy.value.toISOString().split('T')[0]
            // Fetch ±15 días en un solo call — los días ya cacheados se saltan
            const d = new Date(hoy.value)
            const desde = new Date(d); desde.setDate(d.getDate() - 15)
            const hasta = new Date(d); hasta.setDate(d.getDate() + 15)
            await timesStore.ensureRange(
                desde.toISOString().split('T')[0],
                hasta.toISOString().split('T')[0]
            )
            // Si el día cambió mientras esperábamos, descartar esta respuesta
            if (thisRequest !== loadRequestId) return []
            return timesStore.getDayData(fec, 1)
        },
        insert: async (value) => {
            try {
                await tokenService.post('Times', value)
                timesStore.invalidateDay(hoy.value.toISOString().split('T')[0])
                upedateamos()
            } catch(err) {
                notify({ message: 'Error en la Red: '+err.message, position: "center", direction: "up-push" }, 'error',5000)
            }
        },
        onLoaded: (data) => {
            totalHorasChart.value = 0
            for (var i = 0; i < data.length; i++) {
                var pedazos = data[i].tiempo.split(':')
                totalHorasChart.value +=  (Number(pedazos[0])*60) + Number(pedazos[1])
                }
            labelHoras.value = toHoursAndMinutes(totalHorasChart.value)
        }
    })
})

// ------- Donut (Chart.js)

const donutChartData = computed(() => ({
    labels: donutItems.value.map(d => d.project),
    datasets: [{
        data: donutItems.value.map(d => d.time),
        backgroundColor: donutItems.value.map(d => arrayColores[d.orden] || '#AAABA8'),
        borderWidth: 0,
        hoverOffset: 4
    }]
}))

const donutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    rotation: -90,
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) => {
                    const mins = ctx.raw
                    const h = Math.floor(mins / 60)
                    const m = mins % 60
                    return `${ctx.label}: ${h}:${String(m).padStart(2, '0')}`
                }
            }
        }
    }
}

const centerTextPlugin = {
    id: 'centerText',
    beforeDraw(chart) {
        const { ctx, width, height } = chart
        ctx.save()
        ctx.font = '400 20px Poppins, sans-serif'
        ctx.fillStyle = '#1F2937'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText(labelHoras.value, width / 2, height / 2)
        ctx.restore()
    }
}

function cambiaDia(nDias) {
    if (myDataGrid.value) {
        myDataGrid.value.instance.collapseAll(-1)
    }
    // Crear una nueva fecha en lugar de mutar la existente
    const nuevaFecha = new Date(hoy.value)
    nuevaFecha.setDate(nuevaFecha.getDate() + nDias)
    hoy.value = nuevaFecha

    // Debounce: si el usuario sigue presionando flechas, cancelar refresh anterior
    clearTimeout(refreshTimer)
    refreshTimer = setTimeout(() => {
        myDataGrid.value.instance.refresh()
        reloadDonut()
    }, 200)
}

const cbTareas = new DataSource({
    store: new CustomStore({
        key: 'ta_Id',
        load: async () => {
            return await catalogStore.ensureTareas()
        }
    })
})

const cbProjects = new DataSource({
    paginate: false,
    store: new CustomStore({
        key: 'ProjectIndex',
        loadMode: 'raw',
        load: async () => {
            const allProjects = await catalogStore.ensureProyectos()

            // Filtrar los que ya están cargados en el día actual
            const loaded = masterDataSource.items()
            const loadedKeys = new Set(loaded.map(r => r.ts_ProjectId + r.ts_Tipo))

            return allProjects.filter(p => !loadedKeys.has(p.ProjectIndex))
        }
    })
})


function onNewProjectChanged(e) {
    if (e.value == null) {
        if (isVisibleProyecto.value) {
            btnProjectText.value = 'Cancelar'
            hintProject.value = 'Cancelar Agregar Proyecto'
            btnEstiloProyecto.value = 'danger'
            }
        else {
            btnProjectText.value = 'Proyecto'
            hintProject.value = 'Agregar Proyecto'
            btnEstiloProyecto.value = 'default'
        }
    }
    else {
    btnProjectText.value = 'Agregar'
    hintProject.value = 'Aceptar y Grabar Proyecto'
    btnEstiloProyecto.value = 'success'
    }
    defaultProject.value = e.value
}

function changeisVisibleProyecto() {
    if (isVisibleProyecto.value && defaultProject.value !== null) {
        insertProject()
        defaultProject.value = null
        }
    isVisibleProyecto.value = !isVisibleProyecto.value
    if (isVisibleProyecto.value) {
        // Por las dudas que estuviera activo Buscar Tarea
        isVisibleTarea.value = false
        btnTareaText.value = 'Tarea'
        btnEstiloTarea.value = 'default'
        //
        btnProjectText.value = 'Cancelar'
        hintProject.value = 'Cancelar Agregar Proyecto'
        btnEstiloProyecto.value = 'danger'
    }
    else {
        btnProjectText.value = 'Proyecto'
        hintProject.value = 'Agregar Proyecto'
        btnEstiloProyecto.value = 'default'
    }
}

function getTareaDefault() {
    const tareas = catalogStore.tareas
    const proyectos = catalogStore.proyectos

    if (defaultProject.value.slice(-1) == 'p') {
        return tareas.find(item => item.ta_Default == -1)
    }
    else {
        if (proyectos.find(item => item.ProjectIndex === defaultProject.value).pr_Generico == 1)
            return tareas.find(item => item.ta_Default == defaultProject.value.slice(0,-1))
        else
            return tareas.find(item => item.ta_Default == 0)
        }
}


async function insertProject() {

    let dataTarea = getTareaDefault()

    let newBody = {
        usercognito: user,
        userId: authStore.userId,
        fecha: hoy.value.toISOString().split('T')[0],
        projectid: defaultProject.value.slice(0,-1),
        tipo: defaultProject.value.slice(-1),
        tareaid: dataTarea.taID,
        desc: '',
        property1: dataTarea.taProperty1,
        property2: dataTarea.taProperty2,
        minutos: '00:00'
        }

    await masterDataSource.store().insert(newBody)
}

function masSelected(selArray, deselArray, selData) {

    if (selArray) // Es que hizo Deselect
        selArray.forEach(arrayElement => {
            selectedData.value.push( selData.filter(item => item.ts_Id == arrayElement)[0])
        })
    if (deselArray )
        deselArray.forEach(arrayElement => {
            selectedData.value = selectedData.value.filter( item => item.ts_Id != arrayElement)
        })
}


async function loadUserConfig() {
    try {
        const data = await catalogStore.ensureUserConfig()
        if (data && data.us_AreaId == null) {
            notify({ message: "Debes completar tus datos de Perfil de Usuario",  shading: true, displayTime: 3500 }, { position: "center", direction: "up-push" })
            notify({ message: "Click en tu Nombre de Usuario -> Datos del Usuario", shading: true, displayTime: 4000 }, { position: "center", direction: "up-push" })
        }
    } catch(err) {
        console.error('Error en loadUserConfig:', err)
    }
}


onMounted( async () => {

    window.addEventListener('keydown', function(e) {
        if (!keypress) {
            keypress = true
            onKeyDown(e)

        } else {
            return
        }
    })
    window.addEventListener('keyup', function() {
        keypress = false

        })

    // Precargar catálogos en paralelo (cache inteligente)
    loadUserConfig()
    catalogStore.ensureTareas()
    catalogStore.ensureProyectos()

    loadMessages(esMessages)
    locale(navigator.language)
    cambiaDia(0)
})

</script>

<style>

.homecontainer {
    height: 100%;
    overflow: hidden;
}

.calendario {
    height: 48px;
}

.donut-section {
    height: auto;
}

.grilla {
    min-height: 0; /* Importante para flexbox */
    overflow: hidden;
}

#datagrid {
    height: 100% !important;
    width: 100% !important;
}
.flechaizq,
.flechader {
    display: flex;
    align-items: stretch;
}

.flechaizq .dx-button,
.flechader .dx-button {
    height: 100% !important;
    min-height: 100% !important;
}

.btn-outline {
  color: var(--srk-primary);
  background-color: #ffffff;
  border-color: var(--srk-primary);
  font-weight: bold;
  letter-spacing: 0.05em;
}

.btn-outline:hover,
.btn-outline:active,
.btn-outline:focus,
.btn-outline.active {
  background: var(--srk-primary);
  color: #ffffff;
  border-color: var(--srk-primary);
}

.btn-toolbar {
  color: rgb(119, 121, 131);
  background-color: #ffffff;
  border-color: var(--srk-primary);
}

.btn-toolbar:hover,
.btn-toolbar:active,
.btn-toolbar:focus,
.btn-toolbar.active {
  background: var(--srk-primary);
  color: #ffffff;
  border-color: var(--srk-primary);
}

.fondo-badge {
    background: var(--srk-primary);
    color: #ffffff;
    margin-left: 5px;
}



.dia {
    font-size: 1.4rem;
}

.centertext {
  font-size: 22px;
  font-weight: 400;
}
.ghostdata {
    display: none;
}

.dx-datagrid .dx-link[aria-label="Guardar"] {
  color: green;
}
.dx-datagrid .dx-link[aria-label="Eliminar"] {
  color: red;
}
.dx-datagrid .dx-link[aria-label="Modificar"] {
  color: blue;
}
.dx-datagrid .dx-link[aria-label="Cancelar"] {
  color: rgb(123, 119, 119);
}

/* Resto de estilos existentes */
@media (height <= 600px) {

}
.toolbar-menu-separator {
  height: 1px;
  border-bottom: 1px solid #ddd;
}

.toolbar-separator {
  height: 36px;
  margin: 0 5px;
  border-left: 1px solid #ddd;
}

.dx-data-row .cell-highlighted {
    font-size: 1.1rem;
    margin-left: 10px;
}


</style>

